import React from 'react';
import { GridPageStripGamesCategory } from '../GridPageStripGamesCategory';
import { GridPageStripGamesRecommendations } from '../GridPageStripGamesRecommendations';
import { GridPageStripJackpots } from '../GridPageStripJackpots';
import { GridPageStripPromotions } from '../GridPageStripPromotions';
import { GridPageStripType } from '../GridPageStripType';
import { GridPageStripWinners } from '../GridPageStripWinners';
import './GridPageStrip.css';

export const GridPageStrip = ({ strip, typedIndex, categories, setCurrentSubcategoryId }) => {
    switch (strip.stripType) {
    case GridPageStripType.GAMES_CATEGORY:
        return <GridPageStripGamesCategory
            strip={strip}
            typedIndex={typedIndex}
            categories={categories}
            setCurrentSubcategoryId={setCurrentSubcategoryId}
        />;
    case GridPageStripType.GAMES_RECOMMENDATIONS:
        return <GridPageStripGamesRecommendations strip={strip} />;
    case GridPageStripType.WINNERS:
        return <GridPageStripWinners strip={strip} />;
    case GridPageStripType.PROMOTIONS:
        return <GridPageStripPromotions/>;
    case GridPageStripType.JACKPOTS:
        return <GridPageStripJackpots strip={strip} />;
    default:
        console.error('Wrong strip configuration received', strip);
        return null;
    }
};
